import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dc022a5c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc022a5c')) {
      api.createRecord('dc022a5c', component.options)
    } else {
      api.reload('dc022a5c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dc022a5c", function () {
      api.rerender('dc022a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/technocracy/index.vue"
export default component.exports